'use strict'

import MainLayout from './site'

export default MainLayout

/*function docs() {
    // TODO
}*/
